<template>
    <div>
        <CommonPopupFrame :changeHeight="542" :changeHeightUnit="'px'" :changeBottom="0" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <!-- <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div> -->
            <div style="margin-top: 16px; padding: 0 18px; display: flex; justify-content: space-between; align-items: center; position: relative">
                <div style="font-weight: 700; line-height: 24px;" @click="closeCompleteAction">
                    닫기
                </div>
                <div @click="modifyMemberTalkDetail" style="font-weight: 700; color: var(--color-main);">저장</div>
                <!-- <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%)">멤버톡 이름 바꾸기</div> -->
            </div>
            <!-- <div style="margin-top: 16px; padding: 0 18px; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: center; position: relative; border-bottom: 1px solid #f5f5f5;">
                <div @click="closeCompleteAction">
                    <img style="width: 40px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                </div>
                <div @click="modifyMemberTalkDetail" style="font-weight: 700; color: var(--color-main);">적용</div>
                <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%)">세부 설정 바꾸기</div>
            </div> -->
            <div style="flex: 1; background-color: #fff; overflow-y: scroll;">
                <MemberTalkDetailSetting ref="detailSetting" :settingType="settingType" :isOpen="isOpen" :memberTalkIdx="memberTalkIdx" :memberTalkDetailInfo="memberTalkDetail" :isModify="true"></MemberTalkDetailSetting>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame';
import MemberTalkDetailSetting from '@/components/modal/soccerjoin/MemberTalkDetailSetting';
import ResponseCode from '../../../ResponseCode';

const SETTING_TYPE = {
    AGE: 'age',
    TAG: 'tag'
}

export default {
    name: 'ModifyMemberTalkDetail',
    components: { CommonPopupFrame, MemberTalkDetailSetting },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        memberTalkDetail: {
            type: Object,
            default: () => { }
        },
        memberTalkIdx: {
            type: [Number, String],
            default: -1
        },
        settingType: {
            type: String,
            default: SETTING_TYPE.AGE
        }
    },
    data() {
        return {

        }
    },
    methods: {
        async modifyMemberTalkDetail() {
            const memberTalkInfo = this.$refs.detailSetting.emitModfiedMemberTalkDetail()
            if (this.settingType === SETTING_TYPE.AGE) {
                if (memberTalkInfo.age.length === 0) {
                    this.$GlobalStore.showAlert('연령대를 선택 해주세요.')
                    return
                }
            } else if (this.settingType === SETTING_TYPE.TAG) {
                if (memberTalkInfo.tag.length === 0) {
                    this.$GlobalStore.showAlert('태그를 선택 해주세요.')
                    return
                }
            }

            this.$GlobalStore.showProgress()
            // memberTalkInfo.age.sort((a, b) => {
            //     const numA = parseInt(a)
            //     const numB = parseInt(b)
            //     return numA - numB
            // })

            const formData = new FormData()
            formData.append('mode', 'update')
            if (this.settingType === SETTING_TYPE.AGE) {
                formData.append('age', memberTalkInfo.age)
            }

            if (this.settingType === SETTING_TYPE.TAG) {
                formData.append('join_tag', memberTalkInfo.tag)
            }
            // formData.append('max_cnt', memberTalkInfo.maxCnt)
            formData.append('join_idx', this.memberTalkIdx)
            // formData.append('place_id', memberTalkInfo.placeInfo.id);
            // formData.append('place_name', memberTalkInfo.placeInfo.name);
            // formData.append('gps_latitude', memberTalkInfo.placeInfo.gps_latitude);
            // formData.append('gps_longitude', memberTalkInfo.placeInfo.gps_longitude);
            // formData.append('place_address', memberTalkInfo.placeInfo.address);

            const res = await this.$Axios.post('/api/join/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction('detail', memberTalkInfo.age, memberTalkInfo.maxCnt, memberTalkInfo.tag)
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        }
    },
}
</script>

<style scoped></style>